/*
 * Copyright (c) 2018. CPP, Inc. All rights reserved.
 * Also protected by Patent Pending: 15/916,593
 */

const processPhoto = photo => (
  {
    ...photo.fields,
    ...photo.original
  }
)

export default processPhoto
